<template>
    <div>
        <b-form-input type='number' v-model="questNo" placeholder="How Many Questions?" ></b-form-input>
        <br>
        <b-form-group label="Select Difficulty">
            <b-form-radio-group
                id="radio-group-1"
                v-model="selDiff"
                :options="options"
                name="radio-options"
            ></b-form-radio-group>
        </b-form-group><br>
        <b-button variant="outline-primary" @click='callStart'>Start Quiz with {{questNo==''?'?':questNo}} questions</b-button>
    </div>
</template>

<script>
    export default{
        props:{
            start:Function,
        },
        data(){
            return{
                selDiff:'',
                questNo:'',
                options:['easy','medium','hard'],  
            }
        },
        methods:{
            callStart:function(){
                if(this.questNo>0 && this.selDiff){
                    this.start(this.questNo,this.selDiff);
                }
            }
        }
    }
</script>